/**
 * Check if a string is valid JSON
 * @param str - String to check
 * @returns True if valid JSON, false otherwise
 */
export const isJSON = (str: unknown): boolean => {
  if (typeof str !== 'string') return false;
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};
